import { CustomerStateModel } from '../models/customer.model';
import { AuthorizeResult, CreditCheckedPerson, DownPaymentPayload } from '@core/models/initialize-response.model';
import { Subscription } from '@shared/models/subscription-model';
import { HttpErrorResponse } from '@angular/common/http';
import { CustomerResponse } from '../models/customer-response.model';
import { InFlightOrder } from '@core/models/in-flight-order.model';
import { DeliveryAddress } from '../models/private-customer.model';
import { CustomerEquipment } from '../models/customer-equipment';

export class InitiateBankIdVerification {
  public static readonly type = '[BankID] Initiate BankID verification';
  constructor(
    public msisdn: string,
    public email: string
  ) {}
}

export class UpdateCustomerSubscriptionsAction {
  public static readonly type = '[Customer] update customer subscriptions';
  constructor(public customer: CustomerStateModel) {}
}

export class CustomerSignatureUpdateAction {
  public static readonly type = '[Customer] update customer with signature data';
  constructor(public customer: CustomerStateModel) {}
}

export class CustomerCreditCheckAction {
  public static readonly type = '[Credit check] Customer credit check action';
  constructor(
    public firstName: string,
    public lastName: string,
    public ssn: string,
    public runDownPaymentCheck: boolean
  ) {}
}

export class ExistingCustomerFoundAction {
  public static readonly type = '[Existing Customer] Existing customer found action';
  constructor(
    public customerId: string,
    public firstName: string,
    public lastName: string,
    public ssn: string,
    public runDownPaymentCheck: boolean
  ) {}
}

export class ExistingCustomerCreditCheckAction {
  public static readonly type = '[Existing Customer] Existing private customer credit check';
  constructor(
    public customerId: string,
    public runDownPaymentCheck: boolean,
    public firstName?: string,
    public lastName?: string,
    public ssn?: string
  ) {}
}

export class ExistingCustomerCreditCheckSuccessAction {
  public static readonly type = '[Existing Customer] Existing private customer credit check success';
  constructor(
    public authorizeResult: AuthorizeResult,
    public runDownPaymentCheck: boolean
  ) {}
}

export class ExistingCustomerCreditCheckFailedAction {
  public static readonly type = '[Existing Customer Api] Existing private customer credit check failed';
  constructor(public error: HttpErrorResponse) {}
}

export class NewCustomerCreditCheckSuccessAction {
  public static readonly type = '[New customer allowance Api] New customer credit check success';
  constructor(
    public authorizeResult: AuthorizeResult,
    public ssn: string
  ) {}
}

export class NewCustomerCreditCheckFailedAction {
  public static readonly type = '[New customer allowance Api] New customer credit check failed';
  constructor(public error: HttpErrorResponse) {}
}

export class SetCustomerCreditCheckErrorAction {
  public static readonly type = '[Credit check] Set customer credit check error';
  constructor(public message: string) {}
}

export class CustomerDownpaymentCheckAction {
  public static readonly type = '[Customer Api] New customer Downpayment check';
  constructor(public downpaymentPayload: DownPaymentPayload) {}
}

export class DownpaymentSuccessAction {
  public static readonly type = '[Customer Api] New customer Downpayment check success ';
  constructor(public authorizeResult: AuthorizeResult) {}
}

export class DownpaymentFailedAction {
  public static readonly type = '[Customer Api] New customer Downpayment check failed';
  constructor(public error: HttpErrorResponse) {}
}

export class ChangeCustomerAction {
  static readonly type = '[Customer] change customer event';
  constructor(public changeCustomer: string) {}
}

export class CustomerResetAction {
  static readonly type = '[Customer] reset state';
}

export class GetCustomerAction {
  static readonly type = '[Customer Api] Get customer by Id';
  constructor(public customerId: string) {}
}

export class SetCustomerToInitialStateAction {
  static readonly type = '[Customer] Set customer to initial state';
}

export class GetCustomerSuccessAction {
  static readonly type = '[Customer Api] Get customer by Id success';
  constructor(public response: CustomerResponse) {}
}

export class GetCustomerErrorAction {
  static readonly type = '[Customer Api] Get customer by Id error';
  constructor(public error) {}
}

export class UpdateCustomerInfoFromCreditcheck {
  static readonly type = '[Customer] Update new private customer from credit check';
  constructor(public creditCheckPerson: CreditCheckedPerson) {}
}

export class UpdateCustomerEmailAction {
  static readonly type = '[Customer] Update private customer email';
  constructor(public email: string) {}
}

export class UpdateCustomerPhoneAction {
  static readonly type = '[Customer] Update private customer phone';
  constructor(public phone: string) {}
}

export class UpdateInvoiceTypeAction {
  static readonly type = '[Customer] Update update invoice type';
  constructor(public invoiceType: string) {}
}

export class ApiGetExistingSubscriptionsAction {
  public static readonly type = '[Customer Api] Get customers existing subscriptions';
  constructor(public customerId: string) {}
}

export class ApiGetExistingSubscriptionsSuccessAction {
  static readonly type = '[Customer Api] Get customers existing subscriptions success';
  constructor(public subscriptions: Subscription[]) {}
}

export class ApiGetExistingSubscriptionsErrorAction {
  static readonly type = '[Customer Api] Get customers existing subscriptions Error';
  constructor(public error: string) {}
}
export class SetSelectedFromCustomerSearchAction {
  static readonly type = '[Customer] Set existing customer selected from customer search';
}

export class ApiGetInFlightOrdersForCustomerAction {
  static readonly type = '[Customer Api] Get in flight orders for customer';
  constructor(public customerId: string) {}
}

export class ApiGetInFlightOrdersForCustomerSuccessAction {
  static readonly type = '[Customer Api] Get in flight orders for customer success';
  constructor(public inFlightOrders: InFlightOrder[]) {}
}

export class ApiGetInFlightOrdersForCustomerFailedAction {
  static readonly type = '[Customer Api] Get in flight orders for customer failed';
}

export class UpdateDeliveryAddressAction {
  static readonly type = '[Customer] Update customer delivery address';
  constructor(public deliveryAddress: DeliveryAddress) {}
}

export class ExistingCustomerEquipmentAction {
  public static readonly type = '[Customer Api] Existing equipment for customer';
  constructor(public customerId: string) {}
}

export class ExistingCustomerEquipmentSuccessAction {
  public static readonly type = '[Customer Api] Existing equipment for customer success';
  constructor(public customerEquipment: CustomerEquipment[]) {}
}

export class ExistingCustomerEquipmentFailedAction {
  public static readonly type = '[Customer Api] Existing equipment for customer failed';
}

export class ResetBankIdVerificationAction {
  static readonly type = '[Customer Api] Reset BankIdVerification';
}

export class GetBankIdVerificationStatusAction {
  static readonly type = '[Customer Api] Get BankIdVerification status on customer validation';
}

export class GetBankIdVerificationStatusNewCustomerAction {
  static readonly type = '[Customer Api] Get Verification Status for new customer';
}

export class GetBankIdVerificationStatusExistingCustomerAction {
  static readonly type = '[Customer Api] Get Verification Status for existing customer';
}

export class ReinitiateBankIdVerificationAction {
  static readonly type = '[Customer Api] Reinitiate new BankId verification (non-retail) from order details';
  constructor(
    public orderServiceId: string,
    public msisdn?: string,
    public email?: string
  ) {}
}

export class GetBankIdVerificationStatusOrderDetailsAction {
  static readonly type = '[Customer Api] Get Verification Status from order details';
  constructor(
    public code: string,
    public customerId?: string
  ) {}
}

export class AddAuthenticatedBankIdSessionAction {
  static readonly type = '[Customer Api] Add authenticated BankId session for customer';
  constructor(
    public id: string,
    public verificationLinkCode: string
  ) {}
}

export class CreateAuthenticatedVerificationErrorAction {
  static readonly type = '[Customer Api] Create authenticated verification error';
}

export class SetCustomerAuthenticatedInMannyAction {
  static readonly type = '[Customer] Set customer as authenticated in Manny for TwoFA';
}
